
export const configs = {
    service :{
     //   baseUrl : "https://kaidm.test.kaiostech.com",
        baseUrl : "",
        timeout:20000
    },
    system:{
        debug:false
    },
    http:{
        request:{
            methodGet:'GET',
            methodPost: 'POST',
            methodDelete: 'DELETE',
            methodPut:'PUT'
        },
        responseCode: 200,
        responseMsg: {
            created: 'Created Success ! ',
            updated: 'Updated Success !',
            deleted: 'Deleted Success !',
            imported: 'Imported success !',
            exported:'Exported success !',
        }
    },
    default:{
        route: '/',
        serv: "dfc",
        verv: 'v1',
        url: "http:172.31.28.181:8090",
        authServer: 'oauth2',
        prefix:'v1.0'
    },
    fota: {
        prefix:"fota",
        verv: "v1.0",
        host: process.env.REACT_APP_HOST,
        port:process.env.REACT_APP_PORT
    },
    auth: {
        prefix:"dfc",
        verv: "v3.0",
        host: 'https://api.stage.kaiostech.com',
        port:"443"
    },
    onepw: {
        NAMESPACE: "identity.mozilla.com/picl/v1/",
        PBKDF2_ITERATIONS: 1000,
        KEY_LEN: 32,
        SHA256: "sha256",
        BASE64: "base64",
        CHARSET:"utf8"
    },
    hawk: {
        device: {
            device_type: 10,
            brand : 'AlcatelOneTouch',
            model: 'GoFlip2',
            renference: 'OT765-2AALFR1',
            os: 'KaiOS',
            os_version: '2.5.3',
            devcie_id:'1921687188'
        },
        application: {
            id:'lr9Cts0RhbaNRJ5i_gKf'
        },
        partner: {
            id:'ddsMreKpOJixSvYF5cvz'
        }
    },
    cache: {
        expire: 24 * 60 * 60,
        curefList: 'curefList',
        softwareList: 'softwareList',
        productList: 'productList',
        versionList: 'versionList',
        productTypeList: 'productTypeList',
        softwareTypeList: 'softwareTypeList',
        imeiVersionList: 'imeiVersionList',
        imeiGroupList:'imeiGroupList',
        whiteList: 'whiteList',
        blackList: 'blackList',
        eprojectList:'eprojectList',
        publishHistoryList:'publishHistoryList',
        tokenKey:'bearerToken'
    },
    roles:{
        default:"default",
        dev:[
            "admin",
            "manager",
            "operator",
        ],
        test:[
            "T1ADMIN",
            "T1Stuff",
            "T1Manager",
            "T2Stuff",
            "T2Manager",
            "QA",
            "QAedit",
        ],
    },
    menus:{
        "adminRole":"admin",
        "T1ADMIN":"admin",
        "T1Stuff":"default",
        "T1Manager":"manager",
        "T1Engineer":"default",
        "T2Stuff":"default",
        "T2Manager":"manager",
        "QA":"admin",
        "QAedit":"manager",
        "admin":"admin",
        "manager":"manager",
        "operator":"default",
    },
    menuPermsList:[
        {name:"admin",id:"admin"},
        {name:"manager",id:"manager"},
        {name:"default",id:"default"},
    ],
    zone:[
        {"cc":"CV", "offset":"-01:00,-01:00", "city":"Atlantic/Cape_Verde"},
        {"cc":"MA", "offset":"+00:00,+01:00", "city":"Africa/Casablanca"},
        {"cc":"GB", "offset":"+00:00,+01:00", "city":"Europe/London"},
        {"cc":"FR", "offset":"+01:00,+02:00", "city":"Europe/Paris"},
        {"cc":"RS", "offset":"+01:00,+02:00", "city":"Europe/Belgrade"},
        {"cc":"BA", "offset":"+01:00,+02:00", "city":"Europe/Sarajevo", "id":"Europe/Belgrade"},
        {"cc":"CG", "offset":"+01:00,+01:00", "city":"Africa/Brazzaville"},
        {"cc":"HR", "offset":"+01:00,+02:00", "city":"Europe/Zagreb", "id":"Europe/Belgrade"},
        {"cc":"NA", "offset":"+02:00,+02:00", "city":"Africa/Windhoek"},
        {"cc":"JO", "offset":"+02:00,+03:00", "city":"Asia/Amman"},
        {"cc":"EG", "offset":"+02:00,+02:00", "city":"Africa/Cairo"},
        {"cc":"IL", "offset":"+02:00,+03:00", "city":"Asia/Jerusalem"},
        {"cc":"ZW", "offset":"+02:00,+02:00", "city":"Africa/Harare"},
        {"cc":"IQ", "offset":"+03:00,+03:00", "city":"Asia/Baghdad"},
        {"cc":"RU", "offset":"+03:00,+03:00", "city":"Europe/Moscow"},
        {"cc":"KW", "offset":"+03:00,+03:00", "city":"Asia/Kuwait"},
        {"cc":"KE", "offset":"+03:00,+03:00", "city":"Africa/Nairobi"},
        {"cc":"IR", "offset":"+03:30,+04:30", "city":"Asia/Tehran"},
        {"cc":"AE", "offset":"+04:00,+04:00", "city":"Asia/Dubai"},
        {"cc":"AF", "offset":"+04:30,+04:30", "city":"Asia/Kabul"},
        {"cc":"KZ", "offset":"+05:00,+05:00", "city":"Asia/Oral"},
        {"cc":"RU", "offset":"+05:00,+05:00", "city":"Asia/Yekaterinburg"},
        {"cc":"TM", "offset":"+05:00,+05:00", "city":"Asia/Ashgabat"},
        {"cc":"IN", "offset":"+05:30,+05:30", "city":"Asia/Kolkata"},
        {"cc":"LK", "offset":"+05:30,+05:30", "city":"Asia/Colombo"},
        {"cc":"NP", "offset":"+05:45,+05:45", "city":"Asia/Kathmandu"},
        {"cc":"KZ", "offset":"+06:00,+06:00", "city":"Asia/Almaty"},
        {"cc":"KG", "offset":"+06:00,+06:00", "city":"Asia/Bishkek"},
        {"cc":"MM", "offset":"+06:30,+06:30", "city":"Asia/Rangoon"},
        {"cc":"RU", "offset":"+07:00,+07:00", "city":"Asia/Krasnoyarsk"},
        {"cc":"TH", "offset":"+07:00,+07:00", "city":"Asia/Bangkok"},
        {"cc":"ID", "offset":"+07:00,+07:00", "city":"Asia/Jakarta"},
        {"cc":"PH", "offset":"+08:00,+08:00", "city":"Asia/Manila"},
        {"cc":"CN", "offset":"+08:00,+08:00", "city":"Asia/Chongqing"},
        {"cc":"HK", "offset":"+08:00,+08:00", "city":"Asia/Hong_Kong"},
        {"cc":"RU", "offset":"+08:00,+08:00", "city":"Asia/Irkutsk"},
        {"cc":"MY", "offset":"+08:00,+08:00", "city":"Asia/Kuala_Lumpur"},
        {"cc":"AU", "offset":"+08:00,+08:00", "city":"Australia/Perth"},
        {"cc":"TW", "offset":"+08:00,+08:00", "city":"Asia/Taipei"},
        {"cc":"SG", "offset":"+08:00,+08:00", "city":"Asia/Singapore"},
        {"cc":"KR", "offset":"+09:00,+09:00", "city":"Asia/Seoul"},
        {"cc":"JP", "offset":"+09:00,+09:00", "city":"Asia/Tokyo"},
        {"cc":"RU", "offset":"+09:00,+09:00", "city":"Asia/Yakutsk"},
        {"cc":"AU", "offset":"+09:30,+09:30", "city":"Australia/Darwin"},
        {"cc":"AU", "offset":"+09:30,+10:30", "city":"Australia/Adelaide"},
        {"cc":"AU", "offset":"+10:00,+10:00", "city":"Australia/Brisbane"},
        {"cc":"RU", "offset":"+10:00,+10:00", "city":"Asia/Vladivostok"}
      ],
    
}